window.AG = window.AG || {};
"use strict";

AG.constants = {
    MOBILE_MAX_WIDTH: 767,
    priceDateFormat: 'DD/MM/YYYY'
};